<div class="flex-row-container flex-row-container--center mb-2 bg-theme">
  @if (tmcPreferred && tmcPreferredLogoUrl) {
    <section (mouseleave)="tt5.close()">
      <img
        class="heart-img"
        [src]="tmcPreferredLogoUrl"
        alt="Corporate Travel Management (CTM) Preferred supplier"
        i18n-alt="@@CTMPreferredSupplierAlt"
        [ngbTooltip]="tmcPreferredMessage"
        id="CTMPreferredIcon"
        triggers="manual"
        #tt5="ngbTooltip"
        (mouseenter)="tt5.open()"
        (focus)="tt5.open()"
        (blur)="tt5.close()"
        [tabindex]="tmcPreferredMessage ? '0' : '-1'"
        i18n-ngbTooltip="@@CTMPreferred"
      />
    </section>
  }
  @if (clientPreferred || (tmcPreferred && !tmcPreferredLogoUrl)) {
    <section class="container" (mouseleave)="tt1.close()">
      <i
        class="ico-heart pref_icon"
        [ngbTooltip]="preferredMessage"
        triggers="manual"
        #tt1="ngbTooltip"
        (mouseenter)="tt1.open()"
        (focus)="tt1.open()"
        (blur)="tt1.close()"
        [tabindex]="preferredMessage ? '0' : '-1'"
        placement="right"
      ></i>
    </section>
  }
</div>
